import IconAsButton from "../IconAsButton";
import { ReactComponent as VisibilitOff } from "./visibility_off.svg";
import { ReactComponent as VisibilitOn } from "./visibility_on.svg";

export default function ShowPassword({ showPassword, onChange }) {
  return (
    <IconAsButton
      pos="absolute"
      right="12px"
      top="18px"
      onClick={onChange}
      icon={showPassword ? VisibilitOff : VisibilitOn}
      zIndex={1}
    />
  );
}
